import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FileUploadInfo } from './file-upload-info';

@Injectable({ providedIn: 'root' })
export class FileUploadService {
  constructor(private apiService: HttpClient) {}

  upload(url: string, file: File): Observable<FileUploadInfo> {
    const body = new FormData();
    body.append('file', file);
    return this.apiService.post<{ data: FileUploadInfo }>(url, body).pipe(map((response) => response.data));
  }

  getFilename(url: string): string {
    if (url.length === 0) {
      // TODO: Add tests for this service.
      return url;
    }
    return url.split('/').pop();
  }
}
